/** Host canônico do web (login, indicação, painel). */
export const PORTALFLY_ORIGIN = 'https://portalfly.zehmotoca.com.br';

export function isIndicacaoHostname(hostname: string): boolean {
  if (!hostname) return false;
  return hostname === 'indicacao.zehmotoca.com.br' || hostname.startsWith('indicacao.');
}

/** URL absoluta no Portalfly (path deve começar com /). */
export function portalflyUrl(path: string, search = ''): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${PORTALFLY_ORIGIN}${p}${search}`;
}

/** Sai do host indicacao.* (ex. Grafana) e vai para o Portalfly com o mesmo path/query. */
export function redirectIndicacaoHostToPortalfly(): void {
  if (typeof window === 'undefined') return;
  if (!isIndicacaoHostname(window.location.hostname)) return;
  const { pathname, search } = window.location;
  window.location.replace(portalflyUrl(pathname || '/indicacao', search));
}
